
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogHeader, AlertDialogTitle, AlertDialogAction, AlertDialogCancel, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { InternalCandidate } from "../InternalCandidates";

interface DeleteCandidateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  candidate: InternalCandidate;
  onDelete: (candidateId: string) => void;
}

export function DeleteCandidateDialog({
  open,
  onOpenChange,
  candidate,
  onDelete
}: DeleteCandidateDialogProps) {
  const handleDelete = () => {
    onDelete(candidate.id);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-secondary border-primary/20">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Delete Internal Candidate</AlertDialogTitle>
          <AlertDialogDescription className="text-primary-light">
            Are you sure you want to delete <span className="font-medium text-white">{candidate.candidate_name}</span>? 
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel 
            onClick={() => onOpenChange(false)}
            className="border-black text-black bg-white"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleDelete}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
